export type AFormValidationErrors = Record<string, string | undefined>

export class AFormValidationError extends Error {
  readonly errors: AFormValidationErrors

  constructor(errors: AFormValidationErrors) {
    super('Form validation failed')
    this.name = 'AFormValidationError'
    this.errors = errors
  }
}

export const isAFormValidationError = (error: unknown): error is AFormValidationError =>
  error instanceof AFormValidationError
